import { DataType, InverterData, InverterDataComposer, ReadWrite, RegisterTable } from "../lib/inverter.model";

export const V3UpgradeInfo: Partial<RegisterTable> = {
  LOCAL_UPGRADE_STATUS: {
    address: 0x203F,
    name: 'local_upgrade_status',
    dataType: DataType.U16,
    description: `
    Current upgrade progress
    The high byte indicates the current target chip to be upgraded:
    0x00: Not in the upgrade state;
    0x01: Main DSP upgrade;
    0x02: Secondary DSP upgrade;
    0x03: ARM upgrade;
    0x04: FUSE upgrade;
    0x05：BMS upgrade；
    0x06：PCU upgrade；
    0x07：BDU upgrade；
    The low byte indicates the current upgrade progress:
    The progress range is 0-100%`,
    access: ReadWrite.Read,
    quantity: 1,
  },
};

export const ComposeV3UpgradeInfo: Partial<InverterDataComposer> = {
  LOCAL_UPGRADE_STATUS_MODULE_NAME: (data: Partial<InverterData>) => {
    const value = data.LOCAL_UPGRADE_STATUS as number;
    const module = value >> 8;

    switch (module) {
      case 0x00:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'Not in the upgrade state';
        break;
      case 0x01:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'DSPM upgrade';
        break;
      case 0x02:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'DSPS upgrade';
        break;
      case 0x03:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'ARM upgrade';
        break;
      case 0x04:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'FUSE upgrade';
        break;
      case 0x05:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'BMS upgrade';
        break;
      case 0x06:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'PCU upgrade';
        break;
      case 0x07:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'BDU upgrade';
        break;
      default:
        data.LOCAL_UPGRADE_STATUS_MODULE_NAME = 'Unknown';
        break;
    }

    return data;
  },
  LOCAL_UPGRADE_STATUS_MODULE_CODE: (data: Partial<InverterData>) => {
    const value = data.LOCAL_UPGRADE_STATUS as number;
    const module = value >> 8;

    data.LOCAL_UPGRADE_STATUS_MODULE_CODE = module;

    return data;
  },
  LOCAL_UPGRADE_STATUS_PROGRESS: (data: Partial<InverterData>) => {
    const value = data.LOCAL_UPGRADE_STATUS as number;
    const progress = value & 0xFF;

    data.LOCAL_UPGRADE_STATUS_PROGRESS = progress;

    return data;
  },
};
